import React from "react";

const NotFound = () => {
  return (
    <div className="font-bold flex justify-center text-lg mt-10">
      <h2>404 Not Found Data. Reload the Specific url</h2>
    </div>
  );
};

export default NotFound;